// extracted by mini-css-extract-plugin
module.exports = {"container":"image-placeholder_container__W_Q7p","placeholder":"image-placeholder_placeholder__87LW6"};